import { render, staticRenderFns } from "./SocketComponent.vue?vue&type=template&id=1c4b1a3e"
import script from "./SocketComponent.vue?vue&type=script&lang=js"
export * from "./SocketComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/nigel/Documents/bug-fix-3-vue-socket-cluster/node_modules/vue-socket-cluster/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1c4b1a3e', component.options)
    } else {
      api.reload('1c4b1a3e', component.options)
    }
    module.hot.accept("./SocketComponent.vue?vue&type=template&id=1c4b1a3e", function () {
      api.rerender('1c4b1a3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/SocketComponent.vue"
export default component.exports